import React from 'react';
import { cn } from 'lib/utils';

export interface StatsGridProps {
    children: React.ReactNode;
    columns?: 2 | 3 | 4 | 5 | 'auto';
    className?: string;
}

const columnsClass: Record<NonNullable<StatsGridProps['columns']>, string> = {
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
    5: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5',
    auto: 'grid-cols-[repeat(auto-fit,minmax(220px,1fr))]',
};

const StatsGrid: React.FC<StatsGridProps> = ({
    children,
    columns = 'auto',
    className = '',
}) => {
    return (
        <div className={cn('grid gap-3 mb-6', columnsClass[columns], className)}>
            {children}
        </div>
    );
};

export default StatsGrid;
